// src/utils/i18messages/en.js
const en = {
  profile_settings: {
    password_required: "All fields are required.",
    password_mismatch: "New password and confirmation do not match.",
    password_invalid:
      "Password must be at least 8 characters with uppercase, lowercase, number, and special character.",
  },
  register: {
    mustAgreeToTerms: "You must agree to the terms and privacy policy.",
  },
};

export default en;
